import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
import styled from "@emotion/styled";
import { Global } from "@emotion/core";
import globalStyles from 'styles/global';
import typeStyles from 'styles/typography';
import dimensions from "styles/dimensions";
import Footer from "components/Footer";
import Navbar from "components/nav/Navbar";
import 'styles/fonts.scss';

const LayoutContainer = styled.div`
    width: 100%;

    .Layout__content {
        padding-bottom: 5em;

        min-height: calc(100vh - 352px);
        padding-top: 56px;

        @media(min-width: ${dimensions.minwidthTablet}px) {
            min-height: calc(100vh - 475px);
            padding-top: 70px;
        }

        @media(min-width: ${dimensions.maxwidthDesktop}px) {
            padding-top: 100px;
        }
    }
`;

const Layout = ({ children }) => (
    <StaticQuery
        query={graphql`
            query SiteTitleQuery {
                site {
                    siteMetadata {
                        title
                    }
                }
            }
        `}
        render={data => (
            <LayoutContainer className="div">
                <Global styles={[globalStyles, typeStyles]} />
                <div className="Layout">
                    <Navbar />
                    <main className="Layout__content">
                        {children}
                    </main>
                    <Footer />
                </div>
            </LayoutContainer>
        )}
    />
)

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout;
